{
  "scripts": {
    "https://request.eprotect.vantivcnp.com/eProtect/eProtect-api3.js": "sha384-bEAuRPDSvkgvJ6D9akbrtEbMTvZCJH0S+6JsnppQZ19xqBinNPuZLzHDksTwyXtt",
    "https://request.eprotect.vantivprelive.com/eProtect/eProtect-api3.js": "sha384-VM96ZnWRJL1Ez7nVX13O5k0nAYPXEL56O5CZJgzmzo+UkXbnyQljUv07JTX9HiEf"
  }
}